import { GenericEventMeta, WebEventName } from '@invoice-simple/is-events';

import { setUser } from '@sentry/react';

import intercom from 'src/analytics/intercom';
import isEventsIdentify from 'src/analytics/is-events';
import UserModel from 'src/models/UserModel';
import { setAppsFlyerCUID } from 'src/util/appsflyer';
import { updateBrazeCustomAttributes } from 'src/util/braze';

export const updateAnalyticsProviders = ({
  user
}: {
  user: UserModel;
  withReset?: boolean;
}): void => {
  try {
    isEventsIdentify(user.events.forAmplitude());
    updateBrazeCustomAttributes(user.forBraze());
    intercom('update', user.forIntercom());
    setAppsFlyerCUID(user?.id);
    setUser({
      id: user.id,
      username: user.username,
      email: user.email || undefined
    });
  } catch (error) {
    user.trackError('user-update-tracking-services', error);
  }
};

export const trackEvent = <T extends WebEventName>(eventName: T, data?: GenericEventMeta<T>) =>
  UserModel.getInstance().trackAppEventViaApi(eventName, data);
